import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import PasswordModal from './class_SecurityModal';
import { useState } from 'react';

const ReadingModule = ({ module, moduleIndex, expandedModules, toggleModule, expandedClasses, toggleClass, expandedSubClasses, toggleSubClass, expandedSubSubClasses, toggleSubSubClass }) => {
    const navigate = useNavigate();
    const [modalOpen, setModalOpen] = useState(false);
    const [pendingClass, setPendingClass] = useState(null);
    const [pendingClassName, setPendingClassName] = useState('');

    // ক্লাস ইনডেক্স থেকে env key map
    const classKeyMap = [
        'RD10_BASICS', 'RD11_COMPLETION', 'RD12_SUMMARY', 'RD13_TFN', 'RD14_YNN', 'RD15_MCQ', 'RD16_MATCHING1', 'RD17_PEOPLE', 'RD18_HEADINGS',
    ];

    const handleClassClick = (moduleIdx, classIdx, className) => {
        setPendingClass({ moduleIdx, classIdx });
        setPendingClassName(className);
        setModalOpen(true);
    };

    const handlePasswordSuccess = () => {
        if (pendingClass) {
            toggleClass(pendingClass.moduleIdx, pendingClass.classIdx);
        }
        setModalOpen(false);
        setPendingClass(null);
        setPendingClassName('');
    };

    const handleModalClose = () => {
        setModalOpen(false);
        setPendingClass(null);
        setPendingClassName('');
    };

    return (
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
            {/* Module Header */}
            <div
                onClick={() => toggleModule(moduleIndex)}
                className="flex justify-between items-center px-6 py-4 cursor-pointer hover:bg-gray-100 transition"
            >
                <h2 className="text-xl font-semibold text-[#001670]">{module.name}</h2>
                {expandedModules[moduleIndex] ? (
                    <FaChevronUp className="text-[#001670]" />
                ) : (
                    <FaChevronDown className="text-[#001670]" />
                )}
            </div>

            {/* Expanded Module Content */}
            {expandedModules[moduleIndex] && (
                <div className="px-6 pb-4 space-y-2">
                    {module.classes.map((classItem, classIndex) => {
                        const subKey = `${moduleIndex}-${classIndex}`;
                        if (classIndex === 0) {
                            // Class 10: Reading Basics & Completions
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    {/* Class 10 Header */}
                                    <div
                                        className="flex justify-between items-center px-4 py-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition"
                                        onClick={() => handleClassClick(moduleIndex, classIndex, classItem.name)}
                                    >
                                        <h3 className="font-medium text-[#001670]">Class 10: Reading Basics & Completions</h3>
                                        {expandedClasses[subKey] ? (
                                            <FaChevronUp className="text-[#001670]" />
                                        ) : (
                                            <FaChevronDown className="text-[#001670]" />
                                        )}
                                    </div>

                                    {/* Class 10 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* Class Lecture */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Class Lecture: HEXA's IELTS Preparation Coursebook (Reading)</span>
                                            </div>

                                            {/* Guided Practices: Flowchart Completion (expandable) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practices: Flowchart Completion</span>
                                                </div>

                                                {expandedSubClasses[subKey] && (
                                                    <div className="pl-8 pt-2 space-y-2">
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-10-reading-instruction', {
                                                                state: { target: '/class-10-flowchart-practice-01' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 01</span>
                                                            <span className="ml-auto text-sm text-gray-600">Space: The Final Archaeological Frontier</span>
                                                        </div>
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-10-reading-instruction', {
                                                                state: { target: '/class-10-flowchart-practice-02' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 02</span>
                                                            <span className="ml-auto text-sm text-gray-600">The Forgotten Forest</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Guided Practices: Short Question Answer */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubSubClass(subKey, 1)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practices: Short Question Answer</span>
                                                </div>

                                                {expandedSubSubClasses[`${subKey}-1`] && (
                                                    <div className="pl-8 pt-2 space-y-2">
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-10-reading-instruction', {
                                                                state: { target: '/class-10-shortq-practice-01' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 01</span>
                                                            <span className="ml-auto text-sm text-gray-600">Early Telecommunication Devices</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        }
                        else if (classIndex === 1) {
                            // Class 11: Completion Questions
                            const subKey = `${moduleIndex}-${classIndex}`;
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    {/* Class 11 Header */}
                                    <div
                                        className="flex justify-between items-center px-4 py-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition"
                                        onClick={() => handleClassClick(moduleIndex, classIndex, classItem.name)}
                                    >
                                        <h3 className="font-medium text-[#001670]">Class 11: Completion Questions</h3>
                                        {expandedClasses[subKey] ? (
                                            <FaChevronUp className="text-[#001670]" />
                                        ) : (
                                            <FaChevronDown className="text-[#001670]" />
                                        )}
                                    </div>
                                    {/* Class 11 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* Class Lecture */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Class Lecture: HEXA'S IELTS Preparation Coursebook (Reading)</span>
                                            </div>

                                            {/* Guided Practices: Diagram Completion (expandable) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practices: Diagram Completion</span>
                                                </div>

                                                {expandedSubClasses[subKey] && (
                                                    <div className="pl-8 pt-2 space-y-2">
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-11-reading-instruction', {
                                                                state: { target: '/class-11-diagram-practice-01' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 01</span>
                                                            <span className="ml-auto text-sm text-gray-600">Snow-makers (HEXA'S Coursebook)</span>
                                                        </div>
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-11-reading-instruction', {
                                                                state: { target: '/class-11-diagram-practice-02' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 02</span>
                                                            <span className="ml-auto text-sm text-gray-600">Tidal Power (Cambridge 9 Test 4)</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Guided Practices: Sentence Completion */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubSubClass(subKey, 1)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practices: Sentence Completion</span>
                                                </div>

                                                {expandedSubSubClasses[`${subKey}-1`] && (
                                                    <div className="pl-8 pt-2 space-y-2">
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-11-reading-instruction', {
                                                                state: { target: '/class-11-sentence-practice-01' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 01</span>
                                                            <span className="ml-auto text-sm text-gray-600">Snow-makers (HEXA'S Coursebook)</span>
                                                        </div>
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-11-reading-instruction', {
                                                                state: { target: '/class-11-sentence-practice-02' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 02</span>
                                                            <span className="ml-auto text-sm text-gray-600">Forest management in Pennsylvania, USA (C18T2)</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Guided Practices: Table Completion */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubSubClass(subKey, 2)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practices: Table Completion</span>
                                                </div>

                                                {expandedSubSubClasses[`${subKey}-2`] && (
                                                    <div className="pl-8 pt-2 space-y-2">
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-11-reading-instruction', {
                                                                state: { target: '/class-11-table-practice-01' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 01</span>
                                                            <span className="ml-auto text-sm text-gray-600">Urban Farming (C18T1)</span>
                                                        </div>
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-11-reading-instruction', {
                                                                state: { target: '/class-11-table-practice-02' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 02</span>
                                                            <span className="ml-auto text-sm text-gray-600">Early Telecommunication Devices (HEXA'S Coursebook)</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Guided Practices: Note Completion */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubSubClass(subKey, 3)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practices: Note Completion</span>
                                                </div>

                                                {expandedSubSubClasses[`${subKey}-3`] && (
                                                    <div className="pl-8 pt-2 space-y-2">
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-11-reading-instruction', {
                                                                state: { target: '/class-11-note-practice-01' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 01</span>
                                                            <span className="ml-auto text-sm text-gray-600">Nutmeg – a valuable spice (C15T1)</span>
                                                        </div>
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-11-reading-instruction', {
                                                                state: { target: '/class-11-note-practice-02' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 02</span>
                                                            <span className="ml-auto text-sm text-gray-600">Stonehenge (C18T2)</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 2) {
                            // Class 12: Summary Completion Questions
                            const subKey = `${moduleIndex}-${classIndex}`;
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    {/* Class 12 Header */}
                                    <div
                                        className="flex justify-between items-center px-4 py-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition"
                                        onClick={() => handleClassClick(moduleIndex, classIndex, classItem.name)}
                                    >
                                        <h3 className="font-medium text-[#001670]">Class 12: Summary Completion Questions</h3>
                                        {expandedClasses[subKey] ? (
                                            <FaChevronUp className="text-[#001670]" />
                                        ) : (
                                            <FaChevronDown className="text-[#001670]" />
                                        )}
                                    </div>
                                    {/* Class 12 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* Class Lecture */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Class Lecture: HEXA'S IELTS Preparation Coursebook (Reading)</span>
                                            </div>

                                            {/* Guided Practices: Summary Completion (without clues) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practices: Summary Completion (without clues)</span>
                                                </div>

                                                {expandedSubClasses[subKey] && (
                                                    <div className="pl-8 pt-2 space-y-2">
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-12-reading-instruction', {
                                                                state: { target: '/class-12-without-clues-practice-01' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 01</span>
                                                            <span className="ml-auto text-sm text-gray-600">Worldly Wealth (HEXA'S Coursebook)</span>
                                                        </div>
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-12-reading-instruction', {
                                                                state: { target: '/class-12-without-clues-practice-02' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 02</span>
                                                            <span className="ml-auto text-sm text-gray-600">Conquering Earth's space junk problem (C18T1)</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Guided Practices: Summary Completion (with clues) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubSubClass(subKey, 1)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practices: Summary Completion (with clues)</span>
                                                </div>

                                                {expandedSubSubClasses[`${subKey}-1`] && (
                                                    <div className="pl-8 pt-2 space-y-2">
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-12-reading-instruction', {
                                                                state: { target: '/class-12-with-clues-practice-01' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 01</span>
                                                            <span className="ml-auto text-sm text-gray-600">Flawed Beauty: the problem with toughened glass (HEXA'Sbook)</span>
                                                        </div>
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-12-reading-instruction', {
                                                                state: { target: '/class-12-with-clues-practice-02' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 02</span>
                                                            <span className="ml-auto text-sm text-gray-600">I contain multitudes (Cambridge 16 Test 2)</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 3) {
                            // Class 13: True / False / Not Given
                            const subKey = `${moduleIndex}-${classIndex}`;
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    {/* Class 13 Header */}
                                    <div
                                        className="flex justify-between items-center px-4 py-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition"
                                        onClick={() => handleClassClick(moduleIndex, classIndex, classItem.name)}
                                    >
                                        <h3 className="font-medium text-[#001670]">Class 13: True / False / Not Given</h3>
                                        {expandedClasses[subKey] ? (
                                            <FaChevronUp className="text-[#001670]" />
                                        ) : (
                                            <FaChevronDown className="text-[#001670]" />
                                        )}
                                    </div>
                                    {/* Class 13 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            <div>
                                                <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 font-semibold text-lg" onClick={() => toggleSubSubClass(subKey, 0)}>
                                                    <span className="text-xl">⇨</span>
                                                    <span>True / False / Not Given</span>
                                                    {expandedSubSubClasses[`${subKey}-0`] ? <FaChevronUp /> : <FaChevronDown />}
                                                </div>
                                                {expandedSubSubClasses[`${subKey}-0`] && (
                                                    <div className="pl-8 pt-2 space-y-2">
                                                        <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-13-reading-instruction', { state: { target: '/class-13-practice-01' } })}
                                                        >
                                                            <span className="text-md">▪</span>
                                                            <span>Practice 01: The Accidental Rainforest</span>
                                                        </div>
                                                        <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-13-reading-instruction', { state: { target: '/class-13-practice-02' } })}
                                                        >
                                                            <span className="text-md">▪</span>
                                                            <span>Practice 02: Timur Gareyev – blindfold chess champion</span>
                                                        </div>
                                                        <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-13-reading-instruction', { state: { target: '/class-13-practice-03' } })}
                                                        >
                                                            <span className="text-md">▪</span>
                                                            <span>Practice 03: Why we need to protect polar bears</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 4) {
                            // Class 14: Yes / No / Not Given
                            const subKey = `${moduleIndex}-${classIndex}`;
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    {/* Class 14 Header */}
                                    <div
                                        className="flex justify-between items-center px-4 py-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition"
                                        onClick={() => handleClassClick(moduleIndex, classIndex, classItem.name)}
                                    >
                                        <h3 className="font-medium text-[#001670]">Class 14: Yes / No / Not Given</h3>
                                        {expandedClasses[subKey] ? (
                                            <FaChevronUp className="text-[#001670]" />
                                        ) : (
                                            <FaChevronDown className="text-[#001670]" />
                                        )}
                                    </div>
                                    {/* Class 14 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* Class Lecture */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Class Lecture: HEXA'S IELTS Preparation Coursebook (Reading)</span>
                                            </div>

                                            {/* Guided Practices: Yes / No / Not Given (expandable) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practices: Yes / No / Not Given</span>
                                                </div>

                                                {expandedSubClasses[subKey] && (
                                                    <div className="pl-8 pt-2 space-y-2">
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-14-reading-instruction', {
                                                                state: { target: '/class-14-practice-01' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 01</span>
                                                            <span className="ml-auto text-sm text-gray-600">Worldly Wealth (HEXA'S Coursebook)</span>
                                                        </div>
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-14-reading-instruction', {
                                                                state: { target: '/class-14-practice-02' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 02</span>
                                                            <span className="ml-auto text-sm text-gray-600">I contain multitudes (Cambridge 16 Test 2)</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 5) {
                            // Class 15: M.C.Qs
                            const subKey = `${moduleIndex}-${classIndex}`;
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    {/* Class 15 Header */}
                                    <div
                                        className="flex justify-between items-center px-4 py-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition"
                                        onClick={() => handleClassClick(moduleIndex, classIndex, classItem.name)}
                                    >
                                        <h3 className="font-medium text-[#001670]">Class 15: MCQs</h3>
                                        {expandedClasses[subKey] ? (
                                            <FaChevronUp className="text-[#001670]" />
                                        ) : (
                                            <FaChevronDown className="text-[#001670]" />
                                        )}
                                    </div>
                                    {/* Class 15 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* Class Lecture */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Class Lecture: HEXA'S IELTS Preparation Coursebook (Reading)</span>
                                            </div>

                                            {/* Guided Practices: MCQs (expandable) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practices: MCQs</span>
                                                </div>

                                                {expandedSubClasses[subKey] && (
                                                    <div className="pl-8 pt-2 space-y-2">
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-15-reading-instruction', {
                                                                state: { target: '/class-15-practice-01' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 01</span>
                                                            <span className="ml-auto text-sm text-gray-600">Pacific navigation and voyaging (HEXA'S Coursebook)</span>
                                                        </div>
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-15-reading-instruction', {
                                                                state: { target: '/class-15-practice-02' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 02</span>
                                                            <span className="ml-auto text-sm text-gray-600">I contain multitudes (Cambridge 16 Test 2)</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 6) {
                            // Class 16: Matching Information and Matching Sentence Endings
                            const subKey = `${moduleIndex}-${classIndex}`;
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    {/* Class 16 Header */}
                                    <div
                                        className="flex justify-between items-center px-4 py-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition"
                                        onClick={() => handleClassClick(moduleIndex, classIndex, classItem.name)}
                                    >
                                        <h3 className="font-medium text-[#001670]">Class 16: <span style={{color: '#001670'}}>Matching Information</span> and <span style={{color: '#001670'}}>Matching Sentence Endings</span></h3>
                                        {expandedClasses[subKey] ? (
                                            <FaChevronUp className="text-[#001670]" />
                                        ) : (
                                            <FaChevronDown className="text-[#001670]" />
                                        )}
                                    </div>
                                    {/* Class 16 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* Class Lecture */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Class Lecture: HEXA'S IELTS Preparation Coursebook (Reading)</span>
                                            </div>

                                            {/* Guided Practices: Matching Information (expandable) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span className="font-semibold text-lg">Guided Practices: Matching Information</span>
                                                </div>

                                                {expandedSubClasses[subKey] && (
                                                    <div className="pl-8 pt-2 space-y-2">
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-16-reading-instruction', {
                                                                state: { target: '/class-16-matching-info-practice-01' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 01</span>
                                                            <span className="ml-auto text-sm text-gray-600">A second attempt at domesticating the tomato (C17T2)</span>
                                                        </div>
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-16-reading-instruction', {
                                                                state: { target: '/class-16-matching-info-practice-02' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 02</span>
                                                            <span className="ml-auto text-sm text-gray-600">Palm Oil (C17T3)</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Guided Practices: Matching Sentence Endings */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubSubClass(subKey, 1)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span className="font-semibold text-lg">Guided Practices: Matching Sentence Endings</span>
                                                </div>

                                                {expandedSubSubClasses[`${subKey}-1`] && (
                                                    <div className="pl-8 pt-2 space-y-2">
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-16-reading-instruction', {
                                                                state: { target: '/class-16-matching-sentence-practice-01' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 03</span>
                                                            <span className="ml-auto text-sm text-gray-600">Pacific navigation and voyaging (HEXA'S Coursebook)</span>
                                                        </div>
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-16-reading-instruction', {
                                                                state: { target: '/class-16-matching-sentence-practice-02' }
                                                            })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 04</span>
                                                            <span className="ml-auto text-sm text-gray-600">Accidental Rainforest (HEXA'S Coursebook)</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 7) {
                            // Class 17: Matching Features and Matching People (List of People)
                            const subKey = `${moduleIndex}-${classIndex}`;
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    {/* Class 17 Header */}
                                    <div
                                        className="flex justify-between items-center px-4 py-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition"
                                        onClick={() => handleClassClick(moduleIndex, classIndex, classItem.name)}
                                    >
                                        <h3 className="font-medium text-[#001670]">Class 17: Matching Features and Matching People (List of People)</h3>
                                        {expandedClasses[subKey] ? (
                                            <FaChevronUp className="text-[#001670]" />
                                        ) : (
                                            <FaChevronDown className="text-[#001670]" />
                                        )}
                                    </div>
                                    {/* Class 17 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* Class Lecture */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Class Lecture: HEXA'S IELTS Preparation Coursebook (Reading)</span>
                                            </div>
                                            {/* Guided Practices: Matching Features */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practices: Matching Features</span>
                                                </div>
                                                {expandedSubClasses[subKey] && (
                                                    <div className="pl-8 pt-2 space-y-2">
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-17-reading-instruction', { state: { target: '/class-17-matching-features-practice-01' } })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 01</span>
                                                            <span className="ml-auto text-sm text-gray-600">Answers Underground (HEXA'S Coursebook)</span>
                                                        </div>
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-17-reading-instruction', { state: { target: '/class-17-matching-features-practice-02' } })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 02</span>
                                                            <span className="ml-auto text-sm text-gray-600">Forest management in Pennsylvania, USA (C18T1)</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            {/* Guided Practices: Matching People (List of People) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubSubClass(subKey, 1)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practices: Matching People (List of People)</span>
                                                </div>
                                                {expandedSubSubClasses[`${subKey}-1`] && (
                                                    <div className="pl-8 pt-2 space-y-2">
                                                        <div
                                                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                            onClick={() => navigate('/class-17-reading-instruction', { state: { target: '/class-17-matching-people-practice-01' } })}
                                                        >
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Practice 01</span>
                                                            <span className="ml-auto text-sm text-gray-600">Conquering Earth's space junk problem (C18T1)</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 8) {
                            // Class 18: Matching Headings
                            const subKey = `${moduleIndex}-${classIndex}`;
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    {/* Class 18 Header */}
                                    <div
                                        className="flex justify-between items-center px-4 py-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition"
                                        onClick={() => handleClassClick(moduleIndex, classIndex, classItem.name)}
                                    >
                                        <h3 className="font-medium text-[#001670]">Class 18: Matching Headings</h3>
                                        {expandedClasses[subKey] ? (
                                            <FaChevronUp className="text-[#001670]" />
                                        ) : (
                                            <FaChevronDown className="text-[#001670]" />
                                        )}
                                    </div>
                                    {/* Class 18 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* Class Lecture */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Class Lecture: HEXA’S IELTS Preparation Coursebook (Reading)</span>
                                            </div>
                                            {/* Guided Practices: Matching Headings */}
                                            <div>
                                                <div className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg">
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Guided Practices: Matching Headings</span>
                                                </div>
                                                <div className="pl-8 pt-2 space-y-2">
                                                    <div
                                                        className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                        onClick={() => navigate('/class-18-reading-instruction', { state: { target: '/class-18-practice-01' } })}
                                                    >
                                                        <span className="text-xl">&#x25B8;</span>
                                                        <span>Practice 01</span>
                                                        <span className="ml-auto text-sm text-gray-600">Rapid Police Response (HEXA’S Coursebook)</span>
                                                    </div>
                                                    <div
                                                        className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                        onClick={() => navigate('/class-18-reading-instruction', { state: { target: '/class-18-practice-02' } })}
                                                    >
                                                        <span className="text-xl">&#x25B8;</span>
                                                        <span>Practice 02</span>
                                                        <span className="ml-auto text-sm text-gray-600">The Steam Car (C18T3)</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else {
                            // All other classes in Reading Module
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    <div
                                        className="flex justify-between items-center px-4 py-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition"
                                        onClick={() => handleClassClick(moduleIndex, classIndex, classItem.name)}
                                    >
                                        <h3 className="font-medium text-[#001670]">{classItem.name}</h3>
                                        {classItem.subClasses ? (
                                            expandedClasses[`${moduleIndex}-${classIndex}`] ? (
                                                <FaChevronUp className="text-[#001670]" />
                                            ) : (
                                                <FaChevronDown className="text-[#001670]" />
                                            )
                                        ) : null}
                                    </div>
                                    {classItem.subClasses && expandedClasses[`${moduleIndex}-${classIndex}`] && (
                                        <div className="px-4 py-2 space-y-2">
                                            {classItem.subClasses.map((subClass, subIndex) => (
                                                <div key={subIndex} className="border rounded-md">
                                                    <div className="px-4 py-3 bg-gray-50 text-[#001670] font-medium">
                                                        {subClass}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            );
                        }
                    })}
                    <PasswordModal
                        isOpen={modalOpen}
                        onSubmit={handlePasswordSuccess}
                        onClose={handleModalClose}
                        classKey={classKeyMap[pendingClass?.classIdx]}
                        className={pendingClassName}
                    />
                </div>
            )}
        </div>
    );
};

export default ReadingModule;